<!-- Required -->
<ng-container
  *ngIf="
    formGroup &&
    !formGroup.controls[field].valid &&
    formGroup.controls[field].touched &&
    formGroup.controls[field].errors.required
  "
>
  {{
    'general.requiredMsg'
      | translate: { field: translatePfx + '.' + field | translate }
  }}
</ng-container>

<!-- Pattern -->
<ng-container
  *ngIf="
    formGroup &&
    !formGroup.controls[field].valid &&
    formGroup.controls[field].touched &&
    formGroup.controls[field].errors.pattern
  "
>
  {{
    'general.patternMsg'
      | translate: { field: translatePfx + '.' + field | translate }
  }}
</ng-container>

<!-- Max Length -->
<ng-container
  *ngIf="
    formGroup &&
    !formGroup.controls[field].valid &&
    formGroup.controls[field].touched &&
    formGroup.controls[field].errors.maxlength
  "
>
  {{
    'general.maxlengthMsg'
      | translate: { field: translatePfx + '.' + field | translate }
  }}
</ng-container>

<!-- Not same -->
<ng-container
  *ngIf="
    formGroup &&
    !formGroup.controls[field].valid &&
    formGroup.controls[field].touched &&
    formGroup.controls[field].errors.notSame
  "
>
  {{ 'registration.passwordsMsgMatch' | translate }}
</ng-container>
